var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-progress-linear',{staticClass:"ma-0",style:(_vm.progressBarStyle),attrs:{"active":_vm.loading,"color":"primary","indeterminate":true,"height":"4","fixed":""}})
}
var staticRenderFns = []

export { render, staticRenderFns }